import axios from 'axios';
import ENDPOINT from './../../endpoints';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {add0StringToNumberLessThan10} from '@/util/dateTimeUtils';
import {
  REQUEST_CSP_OPERATION_STATUS_MODEL,
} from '@/constants/mis-operation-status/cspOperationStatusConstants';
import {isFailResponse, addLoginUserInfoToPayload} from '@/components/pages/mis-operation-status/common/functionUtils';
import store from '@/store';

export function fetchCspOperationStatusList(payload) {
  let fetcheListPayload = {
    payload
  };
  fetcheListPayload = addLoginUserInfoToPayload(payload, store);
  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.MIS_OPERATION_STATUS.CSP_OPERATION_STATUS.CSP_LIST, fetcheListPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function fetchSvcGrpViewList(payload) {
  let fetcheListPayload = {
    payload
  };
  fetcheListPayload = addLoginUserInfoToPayload(payload, store);
  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.MIS_OPERATION_STATUS.CSP_OPERATION_STATUS.VIEW_LIST, fetcheListPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function repairCspOperationStatusList(payload) {
  // let fetcheListPayload = {
  //   ...payload
  // };
  // fetcheListPayload = addLoginUserInfoToPayload(payload, store);
  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.MIS_OPERATION_STATUS.CSP_OPERATION_STATUS.REPAIR_CSP_LIST, payload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function deleteCspOperationStatusList(payload) {
  // let fetcheListPayload = {
  //   ...payload
  // };
  // fetcheListPayload = addLoginUserInfoToPayload(payload, store);
  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.MIS_OPERATION_STATUS.CSP_OPERATION_STATUS.DELETE_CSP_LIST, payload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updateCspOperationStatusList(payload) {
  // let fetcheListPayload = {
  //   ...payload
  // };
  // fetcheListPayload = addLoginUserInfoToPayload(payload, store);
  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.MIS_OPERATION_STATUS.CSP_OPERATION_STATUS.UPDATE_CSP_LIST, payload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function fetchCspCostDstrbList(payload) {
  let fetcheListPayload = {
    payload
  };
  fetcheListPayload = addLoginUserInfoToPayload(payload, store);
  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.MIS_OPERATION_STATUS.CSP_OPERATION_STATUS.DISTRIBUTION_LIST, fetcheListPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function insertCspCostDstrbList(payload) {
  let fetcheListPayload = {
    payload
  };
  fetcheListPayload = addLoginUserInfoToPayload(payload, store);
  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.MIS_OPERATION_STATUS.CSP_OPERATION_STATUS.INSERT_DISTRIBUTION_LIST, fetcheListPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}




// WEBPACK FOOTER //
// ./src/api/mis-operation-status/csp-operation-status/index.js